import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiMenu, FiX } from 'react-icons/fi';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Chatbots', path: '/chatbots' },
    { name: 'From Listening to Movement', path: 'https://claritynchaos.com/listening_movement/', isExternal: true },
  ];

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-500 ${scrolled ? 'bg-black/80 backdrop-blur-md py-4 border-b border-white/5' : 'bg-transparent py-6'}`} >
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
        <Link to="/" className="text-2xl font-bold tracking-tighter text-white hover:text-cyan-200 transition-colors">
          Clarity<span className="text-cyan-400 font-light">in</span>Chaos
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex space-x-8">
          {navLinks.map((link) => (
            link.isExternal ? (
              <a 
                key={link.name} 
                href={link.path} 
                className="relative text-sm uppercase tracking-widest transition-colors duration-300 text-gray-400 hover:text-white"
              >
                {link.name}
              </a>
            ) : (
              <Link 
                key={link.name} 
                to={link.path} 
                className={`relative text-sm uppercase tracking-widest transition-colors duration-300 ${location.pathname === link.path ? 'text-cyan-400' : 'text-gray-400 hover:text-white'}`}
              >
                {link.name}
                {location.pathname === link.path && (
                  <motion.span layoutId="underline" className="absolute left-0 -bottom-1 w-full h-[1px] bg-cyan-400 shadow-[0_0_10px_rgba(34,211,238,0.8)]" />
                )}
              </Link>
            )
          ))}
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-2xl text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} >
          {mobileMenuOpen ? <FiX /> : <FiMenu />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} className="md:hidden bg-black/95 backdrop-blur-xl border-b border-white/10" >
          <div className="flex flex-col p-6 space-y-4">
            {navLinks.map((link) => (
              link.isExternal ? (
                <a 
                  key={link.name} 
                  href={link.path} 
                  onClick={() => setMobileMenuOpen(false)} 
                  className="text-lg font-medium text-gray-300"
                >
                  {link.name}
                </a>
              ) : (
                <Link 
                  key={link.name} 
                  to={link.path} 
                  onClick={() => setMobileMenuOpen(false)} 
                  className={`text-lg font-medium ${location.pathname === link.path ? 'text-cyan-400' : 'text-gray-300'}`}
                >
                  {link.name}
                </Link>
              )
            ))}
          </div>
        </motion.div>
      )}
    </nav>
  );
};

export default Navbar;